import { Alert, AlertTitle } from "@mui/material";

import type { ReactNode } from "react";

export type FormSavedBannerProps = {
    show?: boolean;
    message?: ReactNode;
};

export default function FormSavedBanner({ show, message }: FormSavedBannerProps) {
    if (!show) return null;

    return <Alert severity="success" variant="outlined"
                  sx={ {
                      backgroundColor: 'rgb(93 171 97)',
                      color: 'rgb(255, 255, 255)',
                      marginTop: '25px',
                      borderColor: '#609540'
                  } }>

        <AlertTitle>Success:</AlertTitle>
        { message || 'Your changes are saved!' }
    </Alert>;
}
